window.rfqModal = {
  showLoader() {
    showModal();
  },

  show(rfqPopupUrl) {
    getModalContent(rfqPopupUrl);
  },

  bind(selector = '[data-type="wc-cta-modal"]:not(.disabled)') {
    $(selector).off('click', handlerClick);
    $(selector).on('click', handlerClick);
  },

  close() {
    $('.modal.in').modal('hide');
  },
};

function handlerClick(event) {
  event.preventDefault();
  if (!isAnyModalOpen()) {
    trackEvent(this);
    sendPushData(this);
    if (isModalNeed(this)) {
      showModal();
      getModalContent(getUrlFromButton(this));
    } else {
      window.location.href = this.getAttribute('data-dx-href');
    }
  }
}


function getUrlFromButton(button) {
  var url = new URL(button.getAttribute('data-href'));
  return url.href;
}

function getModalContent(rfqPopupUrl) {
  $.get({
    url: rfqPopupUrl,
    xhrFields: {
      withCredentials: true,
    },
    success: refreshModalData,
  });
}

function isAnyModalOpen() {
  return typeof bootbox === 'undefined' && $('.modal.in').length > 0;
}

function showModal() {
  var modalClassName = 'rfq-seo-popup';
  var $dialog = bootbox.dialog({
    message: createLoader(),
    className: modalClassName,
    size: 'large',
    onEscape: function () {
      window.habTracker.track('click close service request modal');
      if($('.rfq-seo-popup-stopper').length > 0) {
        return false;
      }
      var $stopperDialog = bootbox.dialog({
        message: createStopper(),
        className: modalClassName + '-stopper',
        size: 'large',
        closeButton: false,
        buttons: [
          {
            label: __("Salir"),
            className: "btn btn-default exit",
            callback: function () {
              window.habTracker.track('click exit service request modal popup');
              $('.' + modalClassName).find('.bootbox-close-button').attr('data-dismiss', 'modal');
              $('.' + modalClassName).modal('hide');
            }
          },
          {
            label: __("Continuar Solicitud"),
            className: "btn btn-primary continue",
            callback: function () {
              window.habTracker.track('click continue service request modal popup');
              $stopperDialog.modal('hide');
            }
          }
        ],
        onEscape: function () {
          $stopperDialog.modal('hide');
        },
      });
      $stopperDialog.bind('shown.bs.modal', function () {
        $('.btn-primary.continue').blur();
        var progress_value = parseInt($('#rfq-seo-popup-content').find('.progress-bar').attr('data-progress'));
        var first_line = '';

        if (progress_value >= 50) {
          first_line = __('Tienes el <strong>{progress_value}% de las preguntas completadas</strong> <br/>', {
            progress_value: progress_value,
          });
        }
        $('#first-line-caption').html(first_line);

        window.habTracker.track('view service request stopper popup');
      });
      return false;
    },
  }).init(function () {
    $('.' + modalClassName).find('.bootbox-close-button').attr('data-dismiss', null);
  });
}

function trackEvent(button) {
  var amplitudeEvent = button.getAttribute('data-amplitude');
  if (amplitudeEvent) {
    var dataAmplitude = {};
    if (IsJsonString(button.getAttribute('data-amplitude-properties'))) {
      dataAmplitude = JSON.parse(
        button.getAttribute('data-amplitude-properties')
      );
    }
    window.habTracker.track(amplitudeEvent, dataAmplitude);
  }
}

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function refreshModalData(data) {
  $('.bootbox-body').html(
    '<div id="rfq-seo-popup-content" class="hidden">' + data + '</div>'
  );
}

function createLoader() {
  return ' \
    <div id="loading-placeholder" style="min-height: 400px;"> \
      <div class="content-placeholder-geometric"> \
        <div class="blocks"> \
          <span class="element first-element"></span> \
          <span class="element second-element"></span> \
          <span class="element third-element"></span> \
        </div> \
      </div> \
    </div>';
}

function createStopper() {
  return ' \
    <div id="rfq-seo-popup-stopper-content"> \
      <p class="stopper-title">' + __("¿Seguro que quieres salir?") + ' </p> \
      <div class="stopeer-caption"> \
        <p id="first-line-caption"></p> \
        <p id="second-line-caption">' + __("Estás a un paso de conseguir tus presupuestos") + '</p> \
      </div> \
      <img src="https://es.habcdn.com/static/img/stopper-01.svg"/> \
    </div>';
}

function isModalNeed(button) {
  return button.getAttribute('data-dx-href') == null || button.getAttribute('data-business-id') != null;
}

function sendPushData(button){
  var item_category = button.getAttribute('data-item-category');
  var item_category_2 = button.getAttribute('data-item-category-2');
  var item_list_name = button.getAttribute('data-tracklist-item');
  var item_list_id = button.getAttribute('data-tracklist-id');
  var item_name = button.getAttribute('data-item-name');
  var item_id = button.getAttribute('data-item-id');

  dataLayer.push({ecommerce: null});
  dataLayer.push({
    'event': 'add_to_cart',
    'ecommerce': {
      'items': [{
        'item_name': item_name,
        'item_id': item_id,
        'price': 1,
        'item_category': item_category,
        'item_category2': item_category_2,
        'quantity': 1,
        'item_list_name': item_list_name,
        'index': item_list_id ?? ''
      }]
    }
  });
}
